const address = require('./address.json');

/**
 * @typedef {Object} SalesClientAddress
 * No additional properties allowed.
 * @property {string} addressText - Full text representation of the address.
 * @property {number|null} rPDataPropertyID - RP Data property ID (number) or null if not available.
 * @property {string} pOBox - P.O. Box address if available.
 * @property {string} unitNumber - Unit number of the property.
 * @property {string} streetNumber - Street number of the property.
 * @property {string} propertyName - Property name (if applicable).
 * @property {string} streetName - Street name of the address.
 * @property {number|null} streetTypeID - Numeric ID representing the street type, or null.
 * @property {string} suburb - Suburb or locality of the address.
 * @property {string} stateText - Full state name or abbreviation.
 * @property {number|null} stateID - Numeric ID representing the state, or null.
 * @property {string} postCode - Postal code of the address.
 * @property {number|null} countryID - Numeric ID representing the country, or null.
 */

/**
 * Sale related validation schemas for client
 * @module schemas/sales/client
 * @property {SalesClientAddress} address
 */
module.exports = {
  address,
};
